import * as core from '../../../../../../../core'
import * as assetOwnership from '../asset-ownership'

export const RESOURCE = {
  payload: {
    description: 'Asset is owned by the institution',
    enumId: core.dms.models.Enum.Id.from({
      partialId: assetOwnership.RESOURCE.payload.partialId,
    }),
    id: 'OWNED',
    name: 'Owned',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
